var exports = {
  "qQ": "ProductAnnouncementModal__LiV3yZ",
  "C7": "ProductAnnouncementModal--open__y7zvK5",
  "aG": "ProductAnnouncementModal__backdrop__jjD9Rf",
  "fM": "ProductAnnouncementModal__content__Ni_qWb",
  "Au": "ProductAnnouncementModal__closeButton__p45_yD",
  "AF": "ProductAnnouncementModal__title__0Z7B1q",
};

module.exports = exports;
